import React, { useState, useEffect } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';

const COOKIE_KEY = 'cookieConsentV1';

const defaultState = {
  necessary: true,
  analytics: false,
  marketing: false,
  accepted: false
};

const CookieConsentBanner = () => {
  const [show, setShow] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [consent, setConsent] = useState(defaultState);

  useEffect(() => {
    const saved = localStorage.getItem(COOKIE_KEY);
    if (!saved) setShow(true);
    else setConsent(JSON.parse(saved));
  }, []);

  const handleAccept = () => {
    const newConsent = { ...consent, analytics: true, marketing: true, accepted: true };
    setConsent(newConsent);
    localStorage.setItem(COOKIE_KEY, JSON.stringify(newConsent));
    setShow(false);
  };

  const handleSaveSettings = () => {
    setConsent({ ...consent, accepted: true });
    localStorage.setItem(COOKIE_KEY, JSON.stringify({ ...consent, accepted: true }));
    setShow(false);
    setShowSettings(false);
  };

  const handleSettings = () => setShowSettings(true);
  const handleCloseSettings = () => setShowSettings(false);

  if (consent.accepted) return null;

  return (
    <>
      {/* Основной баннер */}
      {show && (
        <div style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          width: '100%',
          background: 'rgba(255,255,255,0.97)',
          borderTop: '1px solid #ddd',
          boxShadow: '0 -2px 16px 2px rgba(0,0,0,0.15)',
          zIndex: 9999,
          padding: '18px 12px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          borderRadius: '12px 12px 0 0',
        }}>
          <div style={{
            maxWidth: 700,
            textAlign: 'center',
            marginBottom: 10,
            color: '#222',
            fontSize: 17,
            fontWeight: 500,
            textShadow: '0 1px 3px #fff, 0 0 2px #0002',
            lineHeight: 1.5,
          }}>
            Мы используем cookie для персонализации сервисов и анализа трафика. Оставаясь на сайте, вы соглашаетесь с их применением согласно
            <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ margin: '0 6px', color: '#007bff', fontWeight: 600, textDecoration: 'underline' }}>Политике конфиденциальности</a>
            и
            <a href="/user-agreement" target="_blank" rel="noopener noreferrer" style={{ margin: '0 6px', color: '#007bff', fontWeight: 600, textDecoration: 'underline' }}>Пользовательскому соглашению</a>.
          </div>
          <div>
            <Button variant="primary" onClick={handleAccept} style={{ marginRight: 12, fontSize: 16, fontWeight: 600, minWidth: 120, boxShadow: '0 2px 8px #0001' }}>Принять</Button>
            <Button variant="outline-secondary" onClick={handleSettings} style={{ fontSize: 16, fontWeight: 600, minWidth: 120, color: '#333', background: '#f8f9fa', borderColor: '#bbb', boxShadow: '0 2px 8px #0001' }}>Настроить</Button>
          </div>
        </div>
      )}
      {/* Модальное окно настроек */}
      <Modal show={showSettings} onHide={handleCloseSettings} centered>
        <Modal.Header closeButton>
          <Modal.Title>Настройки cookie</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Check
                type="checkbox"
                label={<b>Обязательные cookie</b>}
                checked
                disabled
              />
              <div style={{ fontSize: 13, color: '#666', marginLeft: 28 }}>
                Необходимы для работы сайта и не могут быть отключены.
              </div>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Check
                type="checkbox"
                label={<b>Аналитические cookie</b>}
                checked={consent.analytics}
                onChange={e => setConsent(c => ({ ...c, analytics: e.target.checked }))}
              />
              <div style={{ fontSize: 13, color: '#666', marginLeft: 28 }}>
                Помогают нам анализировать посещаемость и улучшать сервис.
              </div>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Check
                type="checkbox"
                label={<b>Рекламные cookie</b>}
                checked={consent.marketing}
                onChange={e => setConsent(c => ({ ...c, marketing: e.target.checked }))}
              />
              <div style={{ fontSize: 13, color: '#666', marginLeft: 28 }}>
                Используются для показа персонализированной рекламы.
              </div>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseSettings}>Отмена</Button>
          <Button variant="primary" onClick={handleSaveSettings}>Сохранить</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CookieConsentBanner; 